'use client';

import type { FC } from 'react';
import type { StockData, StockItem } from '../data-market-table/types';
import SmiHeader from '../smi-header/SmiHeader';
import { useTranslations } from '@/lib/locale-context';
import dynamic from 'next/dynamic';

type Props = {
  data: StockData;
};

const DataMarketTable = dynamic(
  () => import('@/components/data-market-table/DataMarketTable'),
  { ssr: false },
);

const DataMarketWrapper: FC<Props> = ({ data }) => {
  const { t } = useTranslations();
  const { SMI, StockIndex, Currency, CommodityCrypto } = data;
  const smiHeader: Pick<
    StockItem,
    'lastPrice' | 'dayChangePercent' | 'dayChangePrice'
  > = StockIndex.filter((smi: StockItem) => smi.isin === 'CH0009980894')[0];
  return (
    <>
      <section className="data-market-wrapper flex w-full flex-col-reverse gap-[18px] lg:flex-row lg:!px-0">
        <div className="flex flex-col gap-[18px] lg:w-2/4">
          <DataMarketTable
            title={t('markets.stockIndices')}
            data={StockIndex}
          />
          <DataMarketTable title={t('markets.currencies')} data={Currency} />
          <DataMarketTable
            title={t('markets.commoditiesCrypto')}
            data={CommodityCrypto}
          />
        </div>
        <div className="flex w-full flex-col gap-[18px] overflow-auto">
          <SmiHeader {...smiHeader} />
          <DataMarketTable
            title=""
            data={SMI}
            columns={['Name', 'Kurs', '∆ absolut', '∆ %', '∆ YTD in %']}
            columnLabels={{
              Name: t('markets.tableColumns.name'),
              Kurs: t('markets.tableColumns.price'),
              '∆ absolut': t('markets.tableColumns.absoluteChange'),
              '∆ %': t('markets.tableColumns.percentageChange'),
              '∆ YTD in %': t('markets.tableColumns.ytdChange'),
            }}
          />
        </div>
      </section>

      {/* We comment this section for now, we will use it later  */}
      {/* <CardWrapper
                cards={usMarkets.map((entry) => ({
                    variant: "marketData",
                    title: entry.name,
                    subtitle: entry.subtitle,
                    price: entry.price,
                    changes: entry.changes["1D"],
                }))}
                className="!p-0"
            /> */}
    </>
  );
};

export default DataMarketWrapper;
